export const TSE_MUNICIPIO_IBGE_ZIP_URL =
  'https://cdn.tse.jus.br/estatistica/sead/odsele/municipio_tse_ibge/municipio_tse_ibge.zip';

export const TSE_MUNICIPIOS_GOLDEN_IBGE_SAO_PAULO = 3550308;
export const TSE_MUNICIPIOS_GOLDEN_CODIGO_TSE_SAO_PAULO = '71072';

export const TSE_MUNICIPIOS_MIN_MAPPINGS = 5500;
export const TSE_MUNICIPIOS_MAX_MAPPINGS = 5800;
